import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { GET_PDP_KEY_SELLING_POINTS } from '@/graphql/queries';
import usePdpId from 'components/consumer/PDP/state/context/usePdpId';
const usePDPKeySellingPoints = () => {
  const $ = _c(11);
  const pdpId = usePdpId();
  const t0 = parseInt(pdpId, 10);
  let t1;
  if ($[0] !== t0) {
    t1 = {
      id: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !pdpId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      variables: t1,
      skip: t2,
      fetchPolicy: "cache-and-network"
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    loading,
    error,
    data
  } = useQuery(GET_PDP_KEY_SELLING_POINTS, t3);
  let t4;
  if ($[5] !== data?.getPDPKeySellingPoints) {
    t4 = data?.getPDPKeySellingPoints || [];
    $[5] = data?.getPDPKeySellingPoints;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== error || $[8] !== loading || $[9] !== t4) {
    t5 = {
      loading,
      error,
      data: t4
    };
    $[7] = error;
    $[8] = loading;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default usePDPKeySellingPoints;